import React from 'react';
import Editor from "componentes/editor";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  FormFeedback
} from 'reactstrap';
import InputMask from 'react-input-mask';

import {
  MdClose,
  MdSave
} from 'react-icons/lib/md';

import Anexo from "componentes/anexo";

const ProcessoForm = ({
  bancos,
  tiposConta,
  tiposRequerente,
  requerente: requerenteJson,
  processo: processoJson,
  infracao,
  quandoMudar,
  limparProcesso,
  salvar,
  history,
  alegacoes
}) => {

  const {
    id,
    situacao = {},
    fase = {},
    dataApresentacao = "",
    ...processo } = processoJson;

  const { cpf, cnpj, endereco = {}, dadosBancarios = {}, tipoRequerente = {}, erroCep, ...requerente } = requerenteJson;
  const cpfOuCnpj = cpf || cnpj || "";
  const faseNome = (id && fase.nome)
    || (infracao.exigibilidade === 0 && "Defesa Prévia")
    || (infracao.exigibilidade === 1 && "Recurso a Jari");
    
  return (
    <Form onSubmit={e => salvar(e, history)}>
      <Card tag="fieldset">
        <CardHeader tag="legend">Requerente</CardHeader>
        <CardBody>
          <Row>
            <Col sm={4}>
              <FormGroup>
                <Label for="requerente_cpfOuCnpj" className="lbl-required">Tipo de Requerente</Label>
                <Input type="select" name="requerente_idTipoRequerente" value={tipoRequerente.id} onChange={quandoMudar} >
                  <option key="" />
                {
                  tiposRequerente.map(tipo => (
                    <option key={tipo.id} value={tipo.id}>{tipo.descricao} </option>
                    )
                  )
                }
                </Input>
              </FormGroup>
            </Col>
            <Col sm={8}/>

            <Col sm={4}>
              <FormGroup>
                <Label for="requerente_cpfOuCnpj"className="lbl-required">CPF/CNPJ</Label>
                <Input name="requerente_cpfOuCnpj" maskChar="" tag={InputMask} mask={cpfOuCnpj.length < 12 ? "999.999.999-999" : "99.999.999/9999-99"} value={cpfOuCnpj} onChange={quandoMudar} />
              </FormGroup>
            </Col>

            <Col sm={4}>
              <FormGroup>
                <Label for="requerente_cnh">CNH</Label>
                <Input maxLength={11} name="requerente_cnh" value={requerente.cnh || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Label for="requerente_identidade">Registro Geral (Com UF)</Label>
                <Input maxLength={15} name="requerente_identidade" value={requerente.identidade || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={12}>
              <FormGroup>
                <Label for="requerente_nome" className="lbl-required">Nome</Label>
                <Input maxLength={255} name="requerente_nome" value={requerente.nome || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>

            <Col sm={3}>
              <FormGroup>
                <Label for="requerente_cep" className="lbl-required">CEP</Label>
                <Input type="tel" name="requerente_cep" maskChar="" tag={InputMask} mask="99999-999" value={endereco.cep || ""} onChange={quandoMudar} invalid={erroCep} />
                <FormFeedback>CEP inválido</FormFeedback>
              </FormGroup>
            </Col>
            <Col offset={9}/>

            <Col sm={12}>
              <FormGroup>
                <Label for="requerente_logradouro" className="lbl-required">Logradouro</Label>
                <Input readOnly name="requerente_logradouro" value={endereco.logradouro || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>

            <Col sm={2}>
              <FormGroup>
                <Label for="requerente_numero" className="lbl-required">Número</Label>
                <Input maxLength={10} name="requerente_numero" value={endereco.numero || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={10}>
              <FormGroup>
                <Label for="requerente_complemento">Complemento</Label>
                <Input maxLength={30} name="requerente_complemento" value={endereco.complemento || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>

            <Col sm={5}>
              <FormGroup>
                <Label for="requerente_bairro" className="lbl-required">Bairro</Label>
                <Input readOnly name="requerente_bairro" value={endereco.bairro || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={2}>
              <FormGroup>
                <Label for="requerente_uf" className="lbl-required">Estado</Label>
                <Input readOnly name="requerente_uf" value={endereco.uf || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={5}>
              <FormGroup>
                <Label for="requerente_cidade" className="lbl-required">Cidade</Label>
                <Input readOnly name="requerente_cidade" value={endereco.municipio || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            
            <Col sm={10}>
              <FormGroup>
                <Label for="requerente_email">Email</Label>
                <Input maxLength={255} type="email" name="requerente_email" value={requerente.email || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={2}>
              <FormGroup>
                <Label for="requerente_telefone">Telefone</Label>
                <Input
                  name="requerente_telefone"
                  maxLength={15}
                  tag={InputMask}
                  mask={requerente.telefone <= 10 ? '(99) 9999-9999?' : '(99) 99999-9999'}
                  formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
                  maskChar=""
                  value={requerente.telefone || ""}
                  onChange={quandoMudar} />
              </FormGroup>
            </Col>

            <Col sm={3}>
              <FormGroup>
                <Label for="requerente_tipoConta">Tipo de Conta</Label>
                <Input type="select" name="requerente_tipoConta" value={dadosBancarios.tipoConta} onChange={quandoMudar} >
                  <option key="" />
                  {
                    tiposConta.map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>{tipo.nome} </option>
                    ))
                  }
                </Input>
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Label for="requerente_idBanco">Banco</Label>
                <Input type="select" value={dadosBancarios.idBanco} name="requerente_idBanco" onChange={quandoMudar}>
                  <option key={-1} value="" />
                  {
                    bancos.map(({ id, mnemonico }) => (
                      <option key={id} value={id}>{`${mnemonico} - ${id}`}</option>
                    ))
                  }
                </Input>
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Label for="requerente_agencia">Agência</Label>
                <Input maxLength={10} name="requerente_agencia" value={dadosBancarios.agencia || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Label for="requerente_conta">Conta</Label>
                <Input maxLength={12} name="requerente_conta" value={dadosBancarios.conta || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card tag="fieldset">
        <CardHeader tag="legend">Dados do Processo</CardHeader>
        <CardBody>
          <Row>
            <Col sm={4}>
              <FormGroup>
                <Label for="fase">Fase</Label>
                <Input plaintext>{faseNome}</Input>
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Label for="fase">Situação</Label>
                <Input plaintext>{situacao.descricao}</Input>

              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Label for="processo_dataApresentacao" className="lbl-required">Data de Apresentação</Label>
                <Input type="date" name="processo_dataApresentacao" value={dataApresentacao.split("T")[0]} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Label for="processo_numeroLegado">Número Legado</Label>
                <Input maxLength={30} name="processo_numeroLegado" value={processo.numeroLegado || ""} onChange={quandoMudar} />
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Label for="numero_Sei">Número do Processo no SEI</Label>
                <Input readOnly name="numero_SEI" value="" />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card tag="fieldset">
        <CardHeader tag="legend">Recurso</CardHeader>
        <CardBody>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <Label className="lbl-required">Alegações</Label>
                <Editor chave="processo" placeholder="Incluir alegações..."/>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card >
      <Anexo habilitarEnvio={true} />
      <br />

      <Row>
        <Col sm={{ size: 12 }} className="col-button text-right">
          {
            !id && <Button type="reset" color="secondary" onClick={limparProcesso}><MdClose size="30" />CANCELAR</Button>
          }
          {'    '}
          <Button type="submit" color="warning" ><MdSave size="30" />SALVAR</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ProcessoForm;



// WEBPACK FOOTER //
// ./src/componentes/ProcessoForm.js